import { render, staticRenderFns } from "./AdminDashOccupancy.vue?vue&type=template&id=8dc8952e&scoped=true"
import script from "./AdminDashOccupancy.vue?vue&type=script&lang=js"
export * from "./AdminDashOccupancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8952e",
  null
  
)

export default component.exports